import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://azaiyvuajixbionrnaux.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF6YWl5dnVhaml4YmlvbnJuYXV4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc5NjU0MTUsImV4cCI6MjA5MzU0MTQxNX0.2Byv8Lcx5OxyODVYjWon7eH9ihfusfC_2GRe0h12gBk';
const ROW_ID = 'leo-family';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// ── FAMILY STATE ──────────────────────────────────────────────────────────────
export async function loadState() {
  const { data, error } = await supabase
    .from('family_state').select('data').eq('id', ROW_ID).single();
  if (error) { console.error('Load error:', error); return null; }
  return data?.data || null;
}

export async function saveState(state) {
  const { error } = await supabase
    .from('family_state')
    .update({ data: state, updated_at: new Date().toISOString() })
    .eq('id', ROW_ID);
  if (error) { console.error('Save error:', error); return false; }
  return true;
}

export function subscribeToChanges(callback) {
  const channel = supabase.channel('family-state-changes')
    .on('postgres_changes', {
      event: 'UPDATE', schema: 'public', table: 'family_state', filter: `id=eq.${ROW_ID}`
    }, (payload) => { if (payload.new?.data) callback(payload.new.data); })
    .subscribe();
  return () => supabase.removeChannel(channel);
}

// ── REWARDS DATABASE ──────────────────────────────────────────────────────────
export async function loadRewards() {
  const { data, error } = await supabase
    .from('rewards').select('*').eq('is_active', true).order('sort_order');
  if (error) { console.error('Load rewards error:', error); return []; }
  return data || [];
}

export async function saveReward(reward) {
  const { data, error } = await supabase
    .from('rewards').insert([reward]).select().single();
  if (error) { console.error('Save reward error:', error); return null; }
  return data;
}

export async function updateReward(id, updates) {
  const { data, error } = await supabase
    .from('rewards').update(updates).eq('id', id).select().single();
  if (error) { console.error('Update reward error:', error); return null; }
  return data;
}

export async function deleteReward(id) {
  const { error } = await supabase.from('rewards').delete().eq('id', id);
  if (error) { console.error('Delete reward error:', error); return false; }
  return true;
}

// ── PENDING TASKS ─────────────────────────────────────────────────────────────
export async function submitPendingTask(task) {
  const { data, error } = await supabase
    .from('pending_tasks').insert([task]).select().single();
  if (error) { console.error('Submit task error:', error); return null; }
  return data;
}

export async function loadPendingTasks() {
  const { data, error } = await supabase
    .from('pending_tasks').select('*')
    .eq('status', 'pending').order('submitted_at');
  if (error) { console.error('Load tasks error:', error); return []; }
  return data || [];
}

export async function updateTaskStatus(id, status) {
  const { error } = await supabase
    .from('pending_tasks').update({ status }).eq('id', id);
  if (error) { console.error('Update task error:', error); return false; }
  return true;
}

export function subscribeToPendingTasks(callback) {
  const channel = supabase.channel('pending-tasks-changes')
    .on('postgres_changes', {
      event: '*', schema: 'public', table: 'pending_tasks'
    }, () => loadPendingTasks().then(callback))
    .subscribe();
  return () => supabase.removeChannel(channel);
}

// ── REDEMPTION REQUESTS ───────────────────────────────────────────────────────
export async function submitRedemptionRequest(request) {
  const { data, error } = await supabase
    .from('redemption_requests').insert([request]).select().single();
  if (error) { console.error('Submit redemption error:', error); return null; }
  return data;
}

export async function loadRedemptionRequests() {
  const { data, error } = await supabase
    .from('redemption_requests').select('*')
    .eq('status', 'pending').order('submitted_at');
  if (error) { console.error('Load redemptions error:', error); return []; }
  return data || [];
}

export async function updateRedemptionStatus(id, status) {
  const { error } = await supabase
    .from('redemption_requests').update({ status }).eq('id', id);
  if (error) { console.error('Update redemption error:', error); return false; }
  return true;
}

export function subscribeToRedemptionRequests(callback) {
  const channel = supabase.channel('redemption-requests-changes')
    .on('postgres_changes', {
      event: '*', schema: 'public', table: 'redemption_requests'
    }, () => loadRedemptionRequests().then(callback))
    .subscribe();
  return () => supabase.removeChannel(channel);
}

// ── PUSH NOTIFICATIONS ────────────────────────────────────────────────────────
export async function requestNotificationPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  const permission = await Notification.requestPermission();
  return permission === 'granted';
}

export function sendNotification(title, body, icon = '⚡') {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  new Notification(title, { body, icon: '/icon-192.png', badge: '/icon-192.png' });
}
